import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import NewsHero from './components/NewsHero';
import NewsFeed from './components/NewsFeed';

export default function News() {
  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Header />
      <main>
        <NewsHero />
        <NewsFeed />
      </main>
      <Footer />
    </div>
  );
}